import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=23c5a3a3&scoped=true&"
import script from "./Building.vue?vue&type=script&lang=js&"
export * from "./Building.vue?vue&type=script&lang=js&"
import style0 from "./Building.vue?vue&type=style&index=0&id=23c5a3a3&scoped=true&lang=css&"
import style1 from "./Building.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5a3a3",
  null
  
)

export default component.exports